import React from 'react';
import {
  Box, Grid, Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

function UnauthorizedScripts() {
    return (
        <Box mt={4}>
            <Grid 
                container
                spacing={3}
                style={{display: 'flex', justifyContent: 'center'}}ßß
            >
                <Grid item xs={8}>
                    <Box>
                        <Alert severity="error">
                            <Typography variant="h5">
                            Payment cannot be processed: It appears there could be an issue with your web browser that may prevent payment processing.
                            {' '}
                            <br />
                            Please clear your cache/cookies and try again.
                            </Typography>
                        </Alert>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default UnauthorizedScripts;